import React from 'react'

import {useCaptcha} from './hook-use-captcha'
/**
 * It's not a bug, is a feature! :D
 * You must use a hook instead
 */
function HookUseCaptcha() {
  const {isActive, siteKey} = useCaptcha()

  return (
    <>
      <p>Captcha Status is active: {isActive ? 'Yes' : 'No'}</p>
      {siteKey && <p>siteKey: {siteKey}</p>}
    </>
  )
}

HookUseCaptcha.displayName = 'HookUseCaptcha'

export default HookUseCaptcha
